import { toast } from "react-toastify";
import { toastConfig } from "../constants";
import fetchCreator from "../utils/fetchCreator";

const client = new fetchCreator();

export const fetchUser = () => client.get("me").then((data) => data);

export const updateUser = (general_profile: any) =>
  client.put("profile", general_profile).then((data) => data);

export const getUserBusinessRequest = (userId: string) =>
  client
    .get(`clouds/business/request/${userId}`)
    .then((result: any) => result)
    .catch((error) => error);

export const createBusinessRequest = (data: any) =>
  client
    .post("clouds/business/request", data)
    .then((result: any) => result)
    .catch((error) => error);

export const addFirebaseToken = (token: any) => {
  client
    .patch("notifications/token", {
      token,
      target: "web",
    })
    .then(() => console.log("Token registrado con éxito"))
    .catch(() =>
      toast.warning(
        "Ocurrió un error y puede que no recibas actualizaciones en la app. Por favor refresca la página.",
        toastConfig
      )
    );
};

export const hasMLRegistration = () =>
  client
    .get("/ecommerce/me")
    .then(() => true)
    .catch(() => false);

export const unlinkMLRegistration = () =>
  client
    .put("/ecommerce/unlink")
    .then(() => true)
    .catch(() => false);
